<main class="main">
  @if (isSignedIn()) {
    <app-nav-menu />
  }
  <div class="content">
    <router-outlet />
  </div>
</main>
